import React from 'react';
import { useDispatch } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import { Form, Button, Segment } from 'semantic-ui-react';
import { resetPhoneNumber } from 'state/resetPhone/actions';

function ResetPhoneForm(userDetail) {
  const dispatch = useDispatch();

  const user = userDetail.data.data;

  const onSubmit = () => {
    const payload = {
      userId: user.id,
      phoneNumber: user.phone,
    };
    dispatch(resetPhoneNumber(payload));
  };

  return (
    <div>
      <FinalForm
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Segment.Group>
              <Segment>
                <h3>User detail</h3>
              </Segment>
              <Segment.Group>
                <Segment>Email: {user.email}</Segment>
                <Segment>Phone Number: {user.phone}</Segment>
                <Segment>
                  <Button content="Reset this account" primary />
                </Segment>
              </Segment.Group>
            </Segment.Group>
          </Form>
        )}
      />
    </div>
  );
}

export default ResetPhoneForm;
